export default "__VITE_ASSET__DxZQYxxy__"